
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/topic/[topic]",
      function () {
        return require("private-next-pages/blog/topic/[topic]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/topic/[topic]"])
      });
    }
  